<template>
  <section>
    <div class="card-item mt-6">
      <h4>
        Parámetros de entrada
        <button :id="hideParamsButtonId" class="button is-button-secondary is-pulled-right" @click="hideParams">
          <i class="fas" :class="[isMenuHidden ? 'fa-angle-down' : 'fa-angle-up']" />
        </button>
      </h4>
      <transition name="slide">
        <div v-if="!isMenuHidden">
          <div id="params" class="columns is-multiline is-mobile">
            <NumberInput
              id="approvedAmount"
              v-model="approvedAmount"
              tooltip="Monto Aprobado (con seguro)"
              label="Monto aprobado" />
            <NumberInput
              id="termAsMonths"
              v-model="termAsMonths"
              tooltip="Plazo en meses"
              label="Plazo" />
            <DateInput
              id="startDate"
              v-model="startDate"
              tooltip="Fecha de firma / desembolso"
              label="Fecha de firma" />
            <NumberInput
              id="startOffset"
              v-model="startOffset"
              :tooltip="'Cantidad de meses que pasan desde la fecha de desembolso'
                +' hasta que se empieza a pagar (sin considerar graces ni delays)'"
              label="Desfase inicial" />
            <NumberInput
              id="graceMonths"
              v-model="graceMonths"
              tooltip="Cantidad de meses de gracia (meses al principio sin pagar pero incluyen intereses)"
              label="Meses de Gracia" />
            <NumberInput
              id="delayMonths"
              v-model="delayMonths"
              tooltip="Cantidad de meses de desfase (sin ningún tipo de cobro)"
              label="Meses Desfase" />
            <NumberInput
              id="delayMonthsOffset"
              v-model="delayMonthsOffset"
              tooltip="Índice (cuota 1 = índice 0) de la cuota en que se comienza a aplicar los meses de delay"
              label="Comienzo meses desfase" />
            <NumberInput
              id="annualRate"
              v-model="annualRate"
              tooltip="Tasa anual"
              label="Tasa anual" />
            <NumberInput
              id="resolution"
              v-model="resolution"
              tooltip="Decimales usados para redondear cálculos"
              label="Cantidad decimales" />
            <NumberInput
              id="payDay"
              v-model="payDay"
              tooltip="Día del mes en que se hará el pago"
              label="Día de pago" />
            <NumberInput
              id="propertyValue"
              v-model="propertyValue"
              tooltip="Valor de la propiedad (tasación)"
              label="Valor Propiedad" />
            <NumberInput
              id="lifeInsurance"
              v-model="lifeInsurance"
              tooltip="Tasa de seguro de desgravamen"
              label="Seguro Desgravamen" />
            <NumberInput
              id="fireInsurance"
              v-model="fireInsurance"
              tooltip="Tasa de seguro de incendio y sismo"
              label="Seguro Incendio" />
            <NumberInput
              id="operatingCost"
              v-model="fireInsurance"
              tooltip="Costos de operación"
              label="GOP" />
            <SelectInput
              id="capitalizationOption"
              v-model="capitalizationOption"
              :items="[
                { text: 'Sí', value: true },
                { text: 'No', value: false }
              ]"
              tooltip="Sí o No. Cuando es sí, capitaliza en el monto a financiar los meses de gracia y seguros"
              label="Capitalizar" />
            <SelectInput
              id="numberOfAnnualDoublePayments"
              v-model="numberOfAnnualDoublePayments"
              :items="[
                { text: 'No', value: 0 },
                { text: '1 cuota', value: 1 },
                { text: '2 cuotas', value: 2 }
              ]"
              tooltip="0 = no / 1 = una cuota doble / 2 = dos cuotas dobles"
              label="Cuotas Dobles" />
            <SelectInput
              v-if="numberOfAnnualDoublePayments > 0"
              id="indexOfFirstDoublePayment"
              v-model="indexOfFirstDoublePayment"
              :items="[
                { text: 'Enero', value: 0 },
                { text: 'Febrero', value: 1 },
                { text: 'Marzo', value: 2 },
                { text: 'Abril', value: 3 },
                { text: 'Mayo', value: 4 },
                { text: 'Junio', value: 5 },
                { text: 'Julio', value: 6 },
                { text: 'Agosto', value: 7 },
                { text: 'Septiembre', value: 8 },
                { text: 'Octubre', value: 9 },
                { text: 'Noviembre', value: 10 },
                { text: 'Diciembre', value: 11 }
              ]"
              tooltip="Índice del primer mes de cuota doble"
              label="1er mes doble" />
            <SelectInput
              v-if="numberOfAnnualDoublePayments > 1"
              id="indexOfSecondDoublePayment"
              v-model="indexOfSecondDoublePayment"
              :items="[
                { text: 'Enero', value: 0 },
                { text: 'Febrero', value: 1 },
                { text: 'Marzo', value: 2 },
                { text: 'Abril', value: 3 },
                { text: 'Mayo', value: 4 },
                { text: 'Junio', value: 5 },
                { text: 'Julio', value: 6 },
                { text: 'Agosto', value: 7 },
                { text: 'Septiembre', value: 8 },
                { text: 'Octubre', value: 9 },
                { text: 'Noviembre', value: 10 },
                { text: 'Diciembre', value: 11 }
              ]"
              tooltip="Índice del segundo mes de cuota doble"
              label="2do mes doble" />
          </div>
          <nav v-if="!isMenuHidden" class="level">
            <div class="level-left" />
            <div class="level-right">
              <b-button
                id="load-default-pe-button"
                rounded
                class="level-item is-button-secondary"
                @click="setDefaultPeru">
                Usar ejemplo Perú
              </b-button>
              <b-button
                id="load-default-cl-button"
                rounded
                class="level-item is-button-secondary"
                @click="setDefaultChile">
                Usar ejemplo Chile
              </b-button>
              <b-button
                id="get-amortization-schedule-button"
                rounded
                class="level-item is-button-primary"
                @click="send">
                Obtener Tabla de Amortización
              </b-button>
            </div>
          </nav>
        </div>
      </transition>
    </div>
  </section>
</template>
<script>
import NumberInput from '@/ui/components/input/NumberInput.vue';
import SelectInput from '@/ui/components/input/SelectInput.vue';
import DateInput from '@/ui/components/input/DateInput.vue';

export default {
  components: { NumberInput, SelectInput, DateInput },
  props: {
    hideParamsButtonId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isMenuHidden: false,
      approvedAmount: 0,
      termAsMonths: 0,
      startDate: '2020-04-20',
      startOffset: 0,
      delayMonths: 0,
      netAmount: 0,
      fireInsurance: 0,
      lifeInsurance: 0,
      propertyValue: 0,
      payDay: 1,
      resolution: 0,
      annualRate: 0,
      delayMonthsOffset: 0,
      graceMonths: 0,
      capitalizationOption: false,
      numberOfAnnualDoublePayments: 0,
      indexOfFirstDoublePayment: 0,
      indexOfSecondDoublePayment: 0,
      operatingCost: 0
    };
  },
  methods: {
    hideParams() {
      this.isMenuHidden = !this.isMenuHidden;
    },
    setDefaultPeru() {
      this.approvedAmount = 206948.8;
      this.termAsMonths = 360;
      this.startDate = '2019-10-29';
      this.startOffset = 1;
      this.graceMonths = 3;
      this.delayMonths = 0;
      this.delayMonthsOffset = 0;
      this.annualRate = 0.12;
      this.resolution = 6;
      this.payDay = 30;
      this.propertyValue = 538720;
      this.lifeInsurance = 0.0005827;
      this.fireInsurance = 0.00011648;
      this.capitalizationOption = true;
      this.numberOfAnnualDoublePayments = 2;
      this.indexOfFirstDoublePayment = 6;
      this.indexOfSecondDoublePayment = 11;
      this.operatingCost = 0;
    },
    setDefaultChile() {
      this.approvedAmount = 1621.035;
      this.termAsMonths = 240;
      this.startDate = '2020-02-06';
      this.startOffset = 1;
      this.graceMonths = 3;
      this.delayMonths = 0;
      this.delayMonthsOffset = 0;
      this.annualRate = 0.0458;
      this.resolution = 6;
      this.payDay = 1;
      this.propertyValue = 1244;
      this.lifeInsurance = 0.000435;
      this.fireInsurance = 0.000183;
      this.capitalizationOption = false;
      this.numberOfAnnualDoublePayments = 0;
      this.operatingCost = 0;

      // this.approvedAmount = 1241.880136;
      // this.termAsMonths = 360;
      // this.startDate = "2020-02-03";
      // this.startOffset = 1;
      // this.graceMonths = 0;
      // this.delayMonths = 0;
      // this.delayMonthsOffset = 0;
      // this.annualRate = 0.0458;
      // this.resolution = 6;
      // this.payDay = 1;
      // this.propertyValue = 1711;
      // this.lifeInsurance = 0.000435;
      // this.fireInsurance = 0.000183;
      // this.capitalizationOption = false;
    },
    send() {
      const data = {
        approvedAmount: this.approvedAmount,
        termAsMonths: this.termAsMonths,
        startDate: this.startDate,
        startOffset: this.startOffset,
        delayMonths: this.delayMonths,
        netAmount: this.netAmount,
        fireInsurance: this.fireInsurance,
        lifeInsurance: this.lifeInsurance,
        propertyValue: this.propertyValue,
        payDay: this.payDay,
        resolution: this.resolution,
        annualRate: this.annualRate,
        delayMonthsOffset: this.delayMonthsOffset,
        graceMonths: this.graceMonths,
        capitalizationOption: this.capitalizationOption,
        numberOfAnnualDoublePayments: this.numberOfAnnualDoublePayments,
        indexOfFirstDoublePayment: this.indexOfFirstDoublePayment,
        indexOfSecondDoublePayment: this.indexOfSecondDoublePayment,
        operatingCost: this.operatingCost
      };
      this.$emit('send', data);
      this.hideParams();
    }
  }
};
</script>
<style scoped>
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}
.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
<style>
#params .form-input:placeholder-shown{
  margin-top: 30px !important;
}
</style>
